/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForEaUnitRate extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForEaUnitRate.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForEaUnitRate>): ProgressDetailsForEaUnitRate {
        let obj = Object.assign(new ProgressDetailsForEaUnitRate(), model);
        ProgressDetailsForEaUnitRate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForEaUnitRate>): ProgressDetailsForEaUnitRate {
        if (!model) return null;
        return ProgressDetailsForEaUnitRate.newInstance(<ProgressDetailsForEaUnitRate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForEaUnitRate) {
        if (!obj) return;

        models.ProgressDetailsForEaUnitRate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForEaUnitRate): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForEaUnitRate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.records_processed === undefined) {
            this.records_processed = 0;
        }
    }

    /**
     * Number of records processed in the run
     */
    records_processed: number;

    /**
     * is the having price sheet access
     */
    has_price_sheet_access: boolean;

    /**
     * is unit rate required to be pulled
     */
    is_unit_rate_required: boolean;

}
